import { CookieKeys } from '@/constants/commons'

export function useRegionIdCookie() {
  return useCookie<number | undefined>(CookieKeys.REGION_ID)
}

export function useHasSmartBannerClosedCookie() {
  return useCookie<boolean | undefined>(CookieKeys.HAS_SMART_BANNER_CLOSED)
}
